<app-shared-dialog [title]="'inventory.edit_settings.title' | translate" 
    [options]="{
        titleIcon: 'pen-cc',
        titleIconColor: 'primary',
        confirmText: 'inventory.product_edit_pricing.save' | translate,
        cancelText: 'inventory.product_edit_pricing.cancel' | translate,
        confirmButtonStyle: 'primary-btn',
        customConfirmButton: true
    }" (cancel)="cancel()">
    <div class="settings-container" [formGroup]="form">
        <!-- PACKAGING -->
        <!-- <h3 class="section-title">{{ 'inventory.edit_settings.packaging' | translate }}</h3> -->

        <!-- Dimensions -->
        <!-- <div class="form-group">
            <label class="form-group-label">{{ 'inventory.edit_settings.dimensions' | translate }}</label>
            <div class="dimension-container">
                <mat-select class="standard-select" [(value)]="dimensionUnit">
                    <mat-select-trigger>
                        <span class="tag">{{ dimensionUnit }}</span>
                    </mat-select-trigger>
                    <mat-option value="cm">cm</mat-option>
                    <mat-option value="m">m</mat-option>
                    <mat-option value="in">in</mat-option>
                </mat-select>

                <div class="dimension-inputs-container">
                    <div class="dimension-input">
                        <input type="number" [(ngModel)]="length" placeholder="26,91" min="0" />
                        <span>{{ dimensionUnit }}</span>
                    </div>
                    <span class="multiply">x</span>
                    <div class="dimension-input">
                        <input type="number" [(ngModel)]="width" placeholder="26,91" min="0" />
                        <span>{{ dimensionUnit }}</span>
                    </div>
                    <span class="multiply">x</span>
                    <div class="dimension-input">
                        <input type="number" [(ngModel)]="height" placeholder="26,91" min="0" />
                        <span>{{ dimensionUnit }}</span>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- Units per pack -->
        <!-- <div class="form-group">
            <label class="form-group-label">{{ 'inventory.edit_settings.units_x_pack' | translate }}</label>
            <div class="standard-input">
                <input type="number" [(ngModel)]="unitsPerPack" placeholder="--" min="0" />
            </div>
        </div> -->

        <!-- ORDER & STOCK -->
        <h3 class="section-title">{{ 'inventory.edit_settings.order_and_Stock' | translate }}</h3>

        <div class="form-group">
            <label class="form-group-label">{{ 'inventory.edit_settings.reorder_level' | translate }}</label>
            <div class="standard-input">
                <input type="number" formControlName="reorder_point" placeholder="--" min ="0" />
            </div>
        </div>

        <div class="form-group">
            <label class="form-group-label">{{ 'inventory.edit_settings.min_order_quantity' | translate }}</label>
            <div class="standard-input">
                <input (input)="sanitize($event)" type="number" formControlName="min_qte" placeholder="--" min="0" />
                <small class="error_ms" *ngIf="form.get('min_qte')?.touched  && form.get('min_qte')?.hasError('required')">
                    {{"common.required_field" | translate}}
                  </small>
                  <small class="error_ms" *ngIf="form.hasError('minQte')">{{ form.getError('minQte') }}</small>
            </div>
        </div>

        <div class="form-group">
            <label class="form-group-label">{{ 'inventory.edit_settings.increment_quantity' | translate }}</label>
            <div class="standard-input">
                <input (input)="sanitize($event)" type="number" formControlName="increment" placeholder="--" min="0" />
                <small *ngIf="form.get('increment')?.touched && form.get('increment')?.hasError('required')">
                    {{"common.required_field" | translate}}
                  </small>
                  <small class="error_ms" *ngIf="form.hasError('increment')">{{ form.getError('increment') }}</small>
                <small class="error_ms" *ngIf="form.hasError('incrementMin')">{{ form.getError('incrementMin') }}</small>
            </div>
        </div>

        <div class="form-group">
            <label class="form-group-label">{{ 'inventory.edit_settings.max_order_quantity' | translate }}</label>
            <div class="standard-input">
                <input (input)="sanitize($event)" type="number" formControlName="max_qte" placeholder="--" />
                <small class="error_ms" *ngIf="form.get('max_qte')?.touched  && form.get('max_qte')?.hasError('required')">
                    {{"common.required_field" | translate}}
                </small>
                <small class="error_ms" *ngIf="form.hasError('minMax')">{{ form.getError('minMax') }}</small>
            </div>
        </div>
    </div>
    <ui-button
      customConfirm
      *appHasPermission="{ module: 'product', action: 'edit' }"
      type="primary"
      [label]="'inventory.product_edit_pricing.save' | translate"
      (click)="save()">
    </ui-button>
</app-shared-dialog>
